module.exports = __webpack_public_path__ + "img/Frame_27.dfae69be.png";